exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-content[data-v-54514e08] {\n    margin-top: 30vh;\n    background: #faf8ef;\n    border: 0;\n}\n.modal-body[data-v-54514e08]{\n    text-align: left;\n    padding-top: 10px;\n    font-size: 32px;\n}\n.modal-footer[data-v-54514e08]{\n    border-top: 0;\n    padding-top: 10px;\n    padding-bottom: 20px;\n}\n.modal-footer a[data-v-54514e08]{\n    width: 100px;\n}\n.modal-footer button[data-v-54514e08]{\n    width: 100px;\n}\n", ""]);

// exports
